module.exports = __webpack_public_path__ + "static/media/aze-map.d383b036.png";